import { useParams } from '../../../../contexts/RouterContext';
import type { ServiceVCS } from '../types';

/**
 * Hook to get the current service based on the service parameter in the URL.
 */
function useService(): ServiceVCS {
  const params = useParams<{ service: ServiceVCS }>();
  return params.service;
}

export default useService;
